var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boolean-search"},[(_vm.activeLastActivity)?_c('last-activity-modal'):_vm._e(),_c('router-view',{key:_vm.pageIndex})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }